import styled from 'styled-components';

import {
  StaticContentSection,
  StaticContentText,
  StaticContentTitle,
} from '@/components/Base/StaticContent/StaticContent.styles';
import { colorGrey300, mediaQueryMobileLargeMin } from '@/styleUtils';

export const Wrapper = styled(StaticContentSection)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  p,
  h4 {
    margin-top: 8px;
  }
  @media ${mediaQueryMobileLargeMin} {
    gap: 24px;
  }
`;
export const BlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const StyledItem = styled(StaticContentText)`
  display: flex;
  align-items: flex-start;
  margin-top: 12px;

  &:first-of-type {
    margin-top: 8px;
  }
  svg {
    margin-top: 5px;
    color: ${colorGrey300};
    margin-right: 8px;
    flex-shrink: 0;
  }
`;
export const StyledItemList = styled(StaticContentText)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  &:first-of-type {
    margin-top: 16px;
  }
`;

export const StaticContentTitleStyled = styled(StaticContentTitle)`
  font-size: 18px;
  line-height: 24px;
`;

export default Wrapper;
